import { User, ShoppingCart, LogOut, Gift } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/hooks/useAuth';
import { useCityNavigation } from '@/hooks/useCityNavigation';

interface UserMenuProps {
  translations: {
    login: string;
    logout: string;
    profile: string;
    orders: string;
  };
}

const UserMenu = ({ translations }: UserMenuProps) => {
  const { user, signOut } = useAuth();
  const { navigateWithCity } = useCityNavigation();

  const handleAuthAction = () => {
    if (user) {
      signOut();
    } else {
      navigateWithCity('/auth');
    }
  };

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="flex flex-col items-center gap-1 group hover:text-primary hover:bg-accent/50 transition-all">
            <User className="h-6 w-6 group-hover:text-primary" style={{ strokeWidth: 1.5 }} />
            <span className="text-base font-normal leading-none group-hover:text-primary">{translations.profile}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48 bg-background/95 backdrop-blur-sm border-border/50">
          <DropdownMenuItem onClick={() => navigateWithCity('/profile')} className="hover:bg-accent/50">
            <User className="h-4 w-4 mr-2" style={{ strokeWidth: 1.5 }} />
            {translations.profile}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigateWithCity('/profile?tab=orders')} className="hover:bg-accent/50">
            <ShoppingCart className="h-4 w-4 mr-2" style={{ strokeWidth: 1.5 }} />
            {translations.orders}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigateWithCity('/profile?tab=occasions')} className="hover:bg-accent/50">
            <Gift className="h-4 w-4 mr-2" style={{ strokeWidth: 1.5 }} />
            My Occasions
          </DropdownMenuItem>
          <DropdownMenuItem onClick={signOut} className="hover:bg-accent/50 text-destructive">
            <LogOut className="h-4 w-4 mr-2" style={{ strokeWidth: 1.5 }} />
            {translations.logout}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <Button variant="ghost" size="sm" className="hidden md:flex flex-col items-center gap-1 group text-foreground hover:text-primary hover:bg-accent/50 transition-all" onClick={handleAuthAction}>
      <User className="h-6 w-6 group-hover:text-primary" style={{ strokeWidth: 1.5 }} />
      <span className="text-base font-normal leading-none group-hover:text-primary">{translations.login}</span>
    </Button>
  );
};

export default UserMenu;